module.exports = __webpack_public_path__ + "img/Group 513.20ac90d1.png";